module.exports = __webpack_public_path__ + "static/img/self-sufficient-1.1a3fe88.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/innovations/self-sufficient-1.png
// module id = oa+D
// module chunks = 1